module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#twitter",
      toString: function () {
        return this.url;
      }
    }